// extracted by mini-css-extract-plugin
export default {"quickLinksWrapper":"style-module--quickLinksWrapper--5baeb","quickLinkCard":"style-module--quickLinkCard--09da3"};